(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Towerofficerlist', Towerofficerlist);

    Towerofficerlist.$inject = ['$resource'];

    function Towerofficerlist ($resource) {
        var resourceUrl =  'api/towerofficerlists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
